export default "__VITE_ASSET__ab25a1d0__"